export const ACTION = {
  FILTER: "FILTER",
  ADD_TO_WATCH_LATER: "ADD_TO_WATCH_LATER",
  ADD_TO_LIKED_VIDEO: "ADD_TO_LIKED_VIDEO",
  REMOVE_FORM_WATCH_LATER: "REMOVE_FORM_WATCH_LATER",
  REMOVE_FORM_LIKED_VIDEO: "REMOVE_FORM_LIKED_VIDEO",
};
